var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.hasCaptchaError)?_c('span',{staticClass:"help is-danger"},[_vm._v(" "+_vm._s(_vm.captchaError)+" ")]):_vm._e()])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"captcha-v2-wrapper"}},[_c('div',{attrs:{"id":"captcha-v2"}})])
}]

export { render, staticRenderFns }